import * as React from 'react';
import { Button } from '../Button/Button';
import { Link } from '../Link/Link';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import type { InfoBannerBlockViewModel } from '~/Blocks/InfoBannerBlock/InfoBannerBlockViewModel.csharp';
import styles from './InfoBanner.module.css';

export interface InfoBannerProps {
    model: InfoBannerBlockViewModel;
    closeInfoBanner: () => void;
    closeTranslation: string;
}

export const InfoBanner: React.FC<React.PropsWithChildren<InfoBannerProps>> = props => {
    const { model, closeInfoBanner, closeTranslation } = props;
    const { infoText, infoUrl } = model;

    return (
        <div className={styles.InfoBanner}>
            <div className={styles.Inner}>
                {infoUrl ? <Link href={infoUrl} label={infoText} external={false} /> : <p>{infoText}</p>}
            </div>
            <Button onClick={closeInfoBanner} className={styles.Close}>
                <SvgIcon className={styles.CloseIcon} iconName="close" />
                <span className="visuallyHidden">{closeTranslation}</span>
            </Button>
        </div>
    );
};
